/* eslint-disable */
(function ($) {
    document.addEventListener('DOMContentLoaded', function () {
        let params = {
            // apiKey: 'CfM4xcxR5jcyUeyWn5734wcrfgQ5tEXqyYx1lLaf',
            apiKey: 'DDrOzO9fZmfDdGJX3pyob0ZSKu33Jwn30gMNuqiW',
            config: {
                preset: 'v8'
            },
        };

        let tryOnModal = document.getElementById('tryOnModal');
        $(document).on("click", '.btn--try-on', function () {
            $(".btn--try-on").each(function(){
                $(this).removeClass("clickedOn");
            })
            $(this).addClass("clickedOn");
        });
        if (tryOnModal) {
            tryOnModal.addEventListener('shown.bs.modal', function () {
                let fittinboxId = 0;
                if($('.btn.try-on').length){
                    fittinboxId = $('.btn.try-on').attr('data-fittinbox-id');
                }
                else if($(".btn--try-on.clickedOn").length){
                    fittinboxId = $(".btn--try-on.clickedOn").attr('data-fittinbox-id');
                }
                fitmixInstance = FitMix.createWidget('my-fitmix-container', params, function () {
                    fitmixInstance.setFrame(String(fittinboxId));

                    // setPupillaryDistance can be called in the createWidget callback, or later
                    // 40 mm is a test value that will show enormous glasses
                    fitmixInstance.setPupillaryDistance(63); // in millimeters
                });

            })
        }
    });
})(jQuery);
